import DesktopTestimonials from './DesktopTestimonials';
import Testimonials from '../../../website-mobile/components/Testimonials/Testimonials';
import '../../../website-mobile/mobile-scope.css';
import styles from './page6.module.css';
import CircleShadeLeft from '../../../assets/newDesktopView/circleShadeLeft.png';
import CircleShadeRight from '../../../assets/newDesktopView/circleShadeRight.png';

export default function Page6() {
    return (
        <div className={styles.page6}>
            <img src={CircleShadeLeft} alt="" className={styles.circleShadeLeft} />
            <img src={CircleShadeRight} alt="" className={styles.circleShadeRight} />
            <div className={styles.bgLines}>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
            </div>
            <div className={styles.contentWrapper}>
                <Testimonials />
            </div>
        </div>
    );
}
